import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Contracts from "../../components/AboutUs/Contracts"

const Contract = () => {
  return (
    <Layout>
      <SEO title="Terms and Conditions" />
      <Contracts />
    </Layout>
  )
}

export default Contract
